import gql from "graphql-tag";

export const EMAIL_REFER_A_FRIEND_MUTATION = gql`
  mutation emailReferAFriend(
    $userId: ID!
    $nameAndEmailInputs: [NameAndEmailInput!]!
    $message: String
  ) {
    emailReferAFriend(
      userId: $userId
      nameAndEmailInputs: $nameAndEmailInputs
      message: $message
    )
  }
`;

export const EMAIL_TESTATOR_REFERRALS = gql`
  mutation emailTestatorReferrals(
    $userId: ID!
    $peopleIds: [ID!]!
    $message: String
  ) {
    emailTestatorReferrals(
      userId: $userId
      peopleIds: $peopleIds
      message: $message
    ) {
      id
      firstNames
      lastName
      fullName
      dateOfBirth
      email
      contactNumber
      phoneCountryCode
      kinship
      gender
      displayName
      educatable
      referralInviteSent
      referralInviteSentTime
      insuranceChildValidation {
        personId
        evaluation
      }
      identityNumber {
        id
        idType
        number
        countryCode
      }
      testatorRelationships {
        id
        relation
        createdAt
      }
      distributionSpecificPercentage {
        id
      }
      distributionSpecificPercentageAlternatives {
        id
      }
      alternativeDistributionSpecificPercentage {
        id
      }
      distributionSpecificPercentageAlternativeBeneficiaries {
        id
      }
      specificDonations {
        id
      }
    }
  }
`;

export const RESEND_TESTATOR_REFERRAL_EMAIL = gql`
  mutation resendTestatorReferralEmail($userId: ID!, $personId: ID!) {
    resendTestatorReferralEmail(userId: $userId, personId: $personId) {
      id
      firstNames
      lastName
      fullName
      dateOfBirth
      email
      contactNumber
      phoneCountryCode
      kinship
      gender
      displayName
      educatable
      referralInviteSent
      referralInviteSentTime
      insuranceChildValidation {
        personId
        evaluation
      }
      identityNumber {
        id
        idType
        number
        countryCode
      }
      testatorRelationships {
        id
        relation
        createdAt
      }
      distributionSpecificPercentage {
        id
      }
      distributionSpecificPercentageAlternatives {
        id
      }
      alternativeDistributionSpecificPercentage {
        id
      }
      distributionSpecificPercentageAlternativeBeneficiaries {
        id
      }
      specificDonations {
        id
      }
    }
  }
`;
